import { environment } from '@env/environment';

const { apiUrl } = environment;

/**
 * ### **ToptenEndpoint**
 *
 * Los endpoints son las URLs de un API o un backend que responden a una petición, en este caso las relacionadas al top 10.
 */
export class ToptenEndpoint {
  /**  Endpoint que retorna información del sidebar que aparece en la sección del top10*/
  static sidebar = `${apiUrl}page/sidebar/top-10/`;
}
